import React from 'react';
import { CopyIconButton } from 'new/elements/Button';
import { getLogCopyText } from 'new/elements/Button/logCopyText';
import { Log } from '../types';

interface LogCopyIconButtonProps {
  log: Log;
  className?: string;
  copiedClassName?: string;
  title?: string;
  label?: string;
  copiedLabel?: string;
}

export const LogCopyIconButton = ({
  log,
  className,
  copiedClassName,
  title = 'Copy log line',
  label,
  copiedLabel,
}: LogCopyIconButtonProps) => (
  <CopyIconButton
    text={getLogCopyText(log)}
    className={className}
    copiedClassName={copiedClassName}
    title={title}
    label={label}
    copiedLabel={copiedLabel}
  />
);
